var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0f0f0;}.b{fill:none;stroke:#7a2581;stroke-linecap:round;stroke-width:3px;}"))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#f0f0f0"
    },
    className: "a",
    cx: 25,
    cy: 25,
    r: 25
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 17)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 16.394,
    transform: "translate(8.679)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 17.358,
    transform: "translate(0 7.715)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProject);
export default __webpack_public_path__ + "static/media/AddProject.f339aa79.svg";
export { ForwardRef as ReactComponent };